var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "156",
      "height": "110",
      "viewBox": "0 0 156 110",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }
  }, [_c('ellipse', {
    attrs: {
      "cx": "78",
      "cy": "102",
      "rx": "62",
      "ry": "6",
      "fill": "#EBEBEB"
    }
  }), _c('rect', {
    attrs: {
      "x": "20",
      "y": "26",
      "width": "7",
      "height": "72",
      "rx": "1",
      "fill": "#455A64"
    }
  }), _c('rect', {
    attrs: {
      "x": "73",
      "y": "26",
      "width": "7",
      "height": "72",
      "rx": "1",
      "fill": "#455A64"
    }
  }), _c('rect', {
    attrs: {
      "x": "16",
      "y": "46",
      "width": "68",
      "height": "7",
      "rx": "1",
      "fill": "#DBDBDB"
    }
  }), _c('rect', {
    attrs: {
      "x": "16",
      "y": "72",
      "width": "68",
      "height": "7",
      "rx": "1",
      "fill": "#DBDBDB"
    }
  }), _c('rect', {
    attrs: {
      "x": "16",
      "y": "94",
      "width": "68",
      "height": "5",
      "rx": "1",
      "fill": "#C8CDD3"
    }
  }), _c('rect', {
    attrs: {
      "x": "28",
      "y": "30",
      "width": "24",
      "height": "16",
      "rx": "2",
      "fill": "#FFC727"
    }
  }), _c('rect', {
    attrs: {
      "x": "40",
      "y": "30",
      "width": "12",
      "height": "16",
      "rx": "2",
      "fill": "#E5B000"
    }
  }), _c('rect', {
    attrs: {
      "x": "54",
      "y": "32",
      "width": "16",
      "height": "14",
      "rx": "2",
      "fill": "#FFC727"
    }
  }), _c('rect', {
    attrs: {
      "x": "28",
      "y": "56",
      "width": "22",
      "height": "16",
      "rx": "2",
      "fill": "#FFC727"
    }
  }), _c('rect', {
    attrs: {
      "x": "39",
      "y": "56",
      "width": "11",
      "height": "16",
      "rx": "2",
      "fill": "#E5B000"
    }
  }), _c('rect', {
    attrs: {
      "x": "52",
      "y": "58",
      "width": "18",
      "height": "14",
      "rx": "2",
      "fill": "#FFD15D"
    }
  }), _c('path', {
    attrs: {
      "d": "M92 38h28",
      "stroke": "#455A64",
      "stroke-width": "3",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M112 30l10 8-10 8",
      "fill": "none",
      "stroke": "#455A64",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('rect', {
    attrs: {
      "x": "100",
      "y": "64",
      "width": "32",
      "height": "24",
      "rx": "2",
      "fill": "#FFC727"
    }
  }), _c('rect', {
    attrs: {
      "x": "116",
      "y": "64",
      "width": "16",
      "height": "24",
      "rx": "2",
      "fill": "#E5B000"
    }
  }), _c('rect', {
    attrs: {
      "x": "112",
      "y": "72",
      "width": "8",
      "height": "8",
      "rx": "1",
      "fill": "#455A64",
      "opacity": "0.28"
    }
  }), _c('path', {
    attrs: {
      "d": "M132 90H98",
      "stroke": "#455A64",
      "stroke-width": "3",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M108 82l-10 8 10 8",
      "fill": "none",
      "stroke": "#455A64",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }